import React from 'react';
import { Badge, Tooltip } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface NotificationBellProps {
  count?: number;
}

const NotificationBell: React.FC<NotificationBellProps> = ({ count = 0 }) => {
  const navigate = useNavigate();

  return (
    <Tooltip title="Notifications">
      <Badge count={count} size="small" offset={[-2, 2]}>
        <BellOutlined
          style={{ fontSize: '20px', color: '#8B9BB4', cursor: 'pointer' }}
          onClick={() => navigate('/admin/alerts')}
        />
      </Badge>
    </Tooltip>
  );
};

export default NotificationBell;
